import { IFlowRaw } from "./model/flowRaw"
import { FlowType } from "./useCases"

// Flow definitions are bundled with the app, one chunk per use case folder
export const loadFlowRaw = async (flowId: FlowType): Promise<IFlowRaw> =>
  (await import(`./useCases/${flowId}/index.ts`)).default
